module.exports = __webpack_public_path__ + "img/img12.0a706488.png";